module.exports = __webpack_public_path__ + "static/media/icon-address-black.a05d74ba.svg";